// Action Types
export const FETCH_COMPETITORS_REQUEST = "FETCH_COMPETITORS_REQUEST";
export const FETCH_COMPETITORS_SUCCESS = "FETCH_COMPETITORS_SUCCESS";
export const FETCH_COMPETITORS_FAILURE = "FETCH_COMPETITORS_FAILURE";

// Action Creators
export const fetchCompetitorsRequest = (ticker) => {
return (dispatch) => {
  dispatch({
    type: FETCH_COMPETITORS_REQUEST,
    payload: ticker,
  });
};
};
export const fetchCompetitorSuccess = (products) => ({
  type: FETCH_COMPETITORS_SUCCESS,
  payload: products,
});
export const fetchCompetitorFailure = (error) => ({
  type: FETCH_COMPETITORS_FAILURE,
  payload: error,
});
